import { useRouter } from "next/router";

import { useGetDeviceType } from "_common/hooks/global";
import BackgroundWrapper    from "_components/atoms/backgroundWrapper";
import ErrorPage            from "_components/atoms/emptyView";
import ImagesTab            from "_components/organisms/imagesTab";
import PopularStreamers     from "_components/organisms/popularStreamers";
import SearchPopularContent from "_components/organisms/searchPopularContent";
import { VideoProcessing }  from "_components/pages/userProfile/tabContent/presentation";
import Header               from "_components/templates/homepage/header";
import useStyles            from "_styles/organisms/searchResultsContainer";

import VideoCardList from "../videoCardList/container";

import {
	ImageLoadingSkeleton,
	LiveStreamSkeleton,
	SearchStreamerSkeleton
} from "./searchResultsSkeleton";
import TopProfile from "./topProfile/index.js";
import TopVideos  from "./topVideos";

const handleBtn = () => {
	const id = document.getElementById ( "input-popover-target" );

	if ( id ) {
		id?.focus ();
	}
};

const component = props => {

	const {
		activeTab,
		loader,
		isDataDepleted,
		isFetchingData,
		data,
		getNextData,
		changeTab,
		searchQuery,
		topCreator,
		topVideos,
		reels
	} = props;

	const dataFlag        = activeTab === "all" ? ( data?.length || topCreator?.user?.name ) : data?.length;
	const { classes }     = useStyles ( { loader, dataFlag } );
	const dummyData       = new Array ( 3 ).fill ( 0 );
	const imagesDummyData = new Array ( 6 ).fill ( 0 );
	const router          = useRouter ();

	const onClickViewMore = () => {
		// opening reel tab
		return router.push ( `/results/${ encodeURIComponent ( searchQuery ) }?tab=reels`, undefined, { shallow: false } );
	};

	return (
		<BackgroundWrapper
			className = { classes.resultsContainer }
			type      = { "secondary" }
		>
			<RenderTab
				activeTab       = { activeTab }
				changeTab       = { changeTab }
				data            = { data }
				dataFlag        = { dataFlag }
				dummyData       = { dummyData }
				getNextData     = { getNextData }
				imagesDummyData = { imagesDummyData }
				isDataDepleted  = { isDataDepleted }
				isFetchingData  = { isFetchingData }
				loader          = { loader }
				onClickViewMore = { onClickViewMore }
				reels           = { reels }
				searchQuery     = { searchQuery }
				topCreator      = { topCreator }
				topVideos       = { topVideos }
			/>
		</BackgroundWrapper>
	);
};

export default component;

const RenderLoader = ( {
	activeTab,
	dummyData,
	imagesDummyData
} ) => {
	const { classes } = useStyles ();

	switch ( activeTab ) {
		case "all": {
			return (
				<>
					<SearchStreamerSkeleton />

					{
						dummyData?.map ( ( _, index ) => (
							<LiveStreamSkeleton key = { index }
								activeTab              = { activeTab }
								index                  = { index }
							/>
						) )
					}
				</>
			);
		}

		case "people": {
			return (
				<>
					{
						dummyData.map ( ( _, index ) => (
							<SearchStreamerSkeleton key = { index }
								activeTab                  = { activeTab }
								index                      = { index }
							/>
						) )
					}

				</>
			);
		}

		case "liveStreams": {
			return (
				<>
					{
						dummyData.map ( ( _, index ) => (
							<LiveStreamSkeleton key = { index }
								activeTab              = { activeTab }
								index                  = { index }
							/>
						) )
					}

				</>
			);
		}

		case "videos": {
			return (
				<>
					{
						dummyData.map ( ( _, index ) => (
							<LiveStreamSkeleton key = { index }
								activeTab              = { activeTab }
								index                  = { index }
							/>
						) )
					}

				</>
			);
		}

		case "images": {
			return (
				<div className = { classes.imageLoaderWrapper }>
					{imagesDummyData.map ( ( _, idx ) => {
						let conditionFlag   = imagesDummyData.length % 3 ? imagesDummyData.length % 3 : 3;
						let topLeftFlag     = idx === 0;
						let topRightFlag    = idx === 2;
						let bottomLeftFlag  = idx === imagesDummyData.length - conditionFlag && idx % 3 === 0;
						let bottomRightFlag = idx === imagesDummyData.length - 1 && idx % 3 === 2;

						return (
							<ImageLoadingSkeleton
								key             = { idx }
								bottomLeftFlag  = { bottomLeftFlag }
								bottomRightFlag = { bottomRightFlag }
								topLeftFlag     = { topLeftFlag }
								topRightFlag    = { topRightFlag }
							/>
						);
					} )}
				</div>

			);
		}

		default:
			return null;
	}
};

function RenderTab ( {
	loader,
	activeTab,
	isDataDepleted,
	isFetchingData,
	dataFlag,
	dummyData,
	searchQuery,
	topCreator,
	topVideos,
	reels,
	onClickViewMore,
	data,
	getNextData,
	changeTab,
	imagesDummyData
} ) {
	const { classes } = useStyles ();
	const deviceType  = useGetDeviceType ();
	const isMobile    = deviceType === "mobile";

	if ( loader ) {
		return (
			<RenderLoader
				activeTab       = { activeTab }
				dummyData       = { dummyData }
				imagesDummyData = { imagesDummyData }
			/>
		);
	}

	if ( ( isDataDepleted && !isFetchingData && !dataFlag ) || !searchQuery ) {

		return (
			<ErrorPage
				enableButton
				btnHandler = { handleBtn }
				btnText    = "Search Again"
				customMsg  = "No Matching Results Found"
				subHeading = "Try searching different keywords"
			/>
		);
	}

	switch ( activeTab ) {
		case "all": {

			return (
				<>

					{ topCreator?.user && (
						<TopProfile
							topProfileData = { topCreator?.user }
						/>
					) }

					{ ( topVideos?.length > 0 ) && (
						<TopVideos
							name      = { topCreator?.user?.name }
							videoList = { topVideos }
						/>

					) }

					{
						// reel section
						reels.length > 0 ? (
							<div className = { classes.reelContainer }>
								<Header onClickViewMore = { onClickViewMore }
									title                  = { "Related Reels" }
								/>

								<VideoCardList
									cardType = { "reel" }
									from     = { "searchReels" }
									list     = { reels.slice ( 0, isMobile ? 2 : 6 ) }
								/>

							</div>
						) : null
					}

					{ data?.length > 0 && (
						<SearchPopularContent
							activeTab      = { activeTab }
							getNextData    = { getNextData }
							isDataDepleted = { isDataDepleted }
							isFetchingData = { isFetchingData }
							videoList      = { data }
						/>

					) }
				</>
			);
		}

		case "people": {
			return (
				<PopularStreamers
					activeTab      = { activeTab }
					changeTab      = { changeTab }
					getNextData    = { getNextData }
					isDataDepleted = { isDataDepleted }
					isFetchingData = { isFetchingData }
					searchQuery    = { searchQuery }
					streamersList  = { data }
				/>

			);
		}

		case "liveStreams": {
			return (
				<SearchPopularContent
					activeTab      = { activeTab }
					getNextData    = { getNextData }
					isDataDepleted = { isDataDepleted }
					isFetchingData = { isFetchingData }
					videoList      = { data }
				/>
			);
		}

		case "videos": {
			return (
				<SearchPopularContent
					activeTab      = { activeTab }
					getNextData    = { getNextData }
					isDataDepleted = { isDataDepleted }
					isFetchingData = { isFetchingData }
					videoList      = { data }
				/>
			);
		}

		case "images": {
			return (
				<ImagesTab
					getNextData    = { getNextData }
					imageList      = { data }
					isDataDepleted = { isDataDepleted }
					isFetchingData = { isFetchingData }
				/>

			);
		}

		case "reels": {
			return (
				<div style = { {
					marginBottom: "65px"
				} }
				>
					<VideoCardList
						activeTab         = { activeTab }
						cardType          = { "reel" }
						from              = { "searchReelTab" }
						getNextData       = { getNextData }
						isDataDepleted    = { isDataDepleted }
						isFetchingData    = { isFetchingData }
						list              = { data }
						startingComponent = { () => <VideoProcessing activeTab = { activeTab } /> }
					/>
				</div>
			);
		}

		default:
			return null;
	}

}